import { render, staticRenderFns } from "./CheckDetail.vue?vue&type=template&id=1fff7fc6&scoped=true"
import script from "./CheckDetail.vue?vue&type=script&lang=js"
export * from "./CheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff7fc6",
  null
  
)

export default component.exports